<template>
  <div :class="$style.container">
    <img
      :class="$style.imageContainer"
      loading="lazy"
      :src="valuationFunnelImage"
      :alt="t('valuationFunnelTile.headerImageAltText')"
    />
    <img
      :class="$style.previewContainer"
      loading="lazy"
      :src="valuationFunnelChart"
      :alt="t('valuationFunnelTile.headerImageAltText')"
    />
    <div :class="$style.textContainer">
      <HgBadge theme="greenlight" small>
        <HgIcon theme="success" :themeClass="$style.iconClass" icon="TrendingUp" size="small" />
        <span :class="$style.badge">
          {{ t('sidebar.propertyValuationBox.badge') }}
        </span>
      </HgBadge>
      <h2 :class="$style.catchyText">
        {{ t('sidebar.propertyValuationBox.title') }}
      </h2>
      <p :class="$style.descriptiveText">
        {{ t('sidebar.propertyValuationBox.text') }}
      </p>
      <HgButton
        tag="a"
        :class="$style.ctaButton"
        :href="valuationFunnelUrl"
        @click="trackValuationBoxCta"
        >{{ t('sidebar.propertyValuationBox.ctaButton') }}</HgButton
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import { HgBadge, HgButton, HgIcon } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import valuationFunnelImage from '@/assets/valuation-funnel-hg-image.webp';
import valuationFunnelChart from '@/assets/valuation-funnel-price-chart.svg?url';
import { trackValuationBoxCta } from '@/tracking';
import { getValuationFunnelUrl } from '@/utils/functions';

const { t } = useI18n();

const valuationFunnelUrl = computed<string>((): string => getValuationFunnelUrl(t));
</script>
<style lang="scss" module>
@use '@/styles/variables' as *;

.container {
  position: relative;
  background-color: $color-blue-0;
  border-radius: $space-50;
}

.imageContainer {
  height: 344px;
  object-fit: cover;
  border-radius: $space-50 $space-50 0 0;
}

.textContainer {
  padding: 0 $space-100 $space-150;
  margin-top: $space-250;
}

.previewContainer {
  position: absolute;
  top: 26%;
  left: 50%;
  width: 286px;
  height: 208px;
  transform: translateX(-50%);
}

.badge {
  height: $space-150;
  padding: 2px $space-50;
}

img {
  width: 100%;
  height: auto;
}

.iconClass {
  margin-top: $space-25;

  @include color-icon($color-green-100);
}

.catchyText {
  margin-top: $space-100;
  margin-bottom: 0;
  color: $color-blue-100;

  @include heading-2;
}

.descriptiveText {
  margin-top: $space-25;
  margin-bottom: $space-150;
  color: $color-grey-120;

  @include body-2;
}

.ctaButton {
  bottom: 0;
  width: 100%;
}
</style>
